import Item from 'semantic-ui-react/dist/es/views/Item';
import './Item.css';

export default Item;
